import { RG_TYPE } from '../../types/rg-type.js';

/** list of objects who's size is affected by their children */
const SizeBasedOnChildren = [
    RG_TYPE.Building,
    RG_TYPE.Apartment,
    RG_TYPE.Module,
    RG_TYPE.Balcony,
    RG_TYPE.Core,
    RG_TYPE.TechnicalSpace,
    RG_TYPE.Corridor,
    RG_TYPE.Entrance
];

export { SizeBasedOnChildren };
//# sourceMappingURL=size-based-on-children.js.map
